import type { ShipmentExceptionTypesResponse } from './api';

export const normalizeShipmentExceptionTypes = (
  list: ShipmentExceptionTypesResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
